import React, { useState } from 'react';
import {
    Box, Typography, Grid, TextField, Button,
    FormControl, InputLabel, Select, MenuItem,
    Paper, Divider, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, RadioGroup,
    FormControlLabel, Radio, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle,
    Chip, OutlinedInput
} from '@mui/material';

const ListeningTrainingUnit = () => {
    // State for Student Roster
    const [studentRoster, setStudentRoster] = useState({
        students: [{ name: '', id: '', course: '', year: '', session: '', languages: [] }]
    });

    // State for Supervisor List
    const [supervisorList, setSupervisorList] = useState({
        supervisors: [{ name: '', languages: [] }]
    });

    // State for Therapy Slots (Clinician List)
    const [therapySlots, setTherapySlots] = useState({
        unit: '',
        id: '',
        client: '',
        diagnosis: '',
        device: '',
        language: '',
        session: '',
        supervisor: '',
        clinicianCourse: '',
        clinicianYear: '',
        clinicianName: '',
        room: '',
        fromDate: '',
        toDate: '',
        days: '',
        timings: ''
    });

    // State for Attendance
    const [attendance, setAttendance] = useState({
        unit: '',
        date: '',
        fromDate: '',
        toDate: '',
        attendanceData: []
    });

    // State for Therapy Video
    const [therapyVideo, setTherapyVideo] = useState({
        opNumber: '',
        caseName: '',
        studentClinician: '',
        date: '',
        videoFile: null,
        description: ''
    });

    // State for Report Submission
    const [pretherapy, setPretherapy] = useState({
        opNumber: '',
        caseName: '',
        studentClinician: '',
        supervisor: '',
        ageGender: '',
        language: '',
        device: '',
        time: '',
        days: '',
        roomNo: ''
    });

    const [lessonPlan, setLessonPlan] = useState({
        opNumber: '',
        caseName: '',
        ageGender: '',
        lessonPlanFile: null,
        device: '',
        supervisorName: '',
        time: '',
        days: '',
        roomNo: ''
    });

    const [progressReport, setProgressReport] = useState({
        opNumber: '',
        caseName: '',
        ageGender: '',
        reportFile: null,
        device: '',
        supervisorName: '',
        time: '',
        days: '',
        roomNo: ''
    });

    // State for Supervisor sections
    const [supervisorPretherapy, setSupervisorPretherapy] = useState({
        opNumber: '',
        caseName: '',
        ageGender: '',
        language: '',
        device: '',
        studentName: '',
        time: '',
        days: '',
        roomNo: ''
    });

    const [supervisorLessonPlan, setSupervisorLessonPlan] = useState({
        opNumber: '',
        caseName: '',
        ageGender: '',
        lessonPlanFile: null,
        device: '',
        studentName: '',
        time: '',
        days: '',
        roomNo: ''
    });

    const [supervisorProgressReport, setSupervisorProgressReport] = useState({
        opNumber: '',
        caseName: '',
        ageGender: '',
        reportFile: null,
        device: '',
        studentName: '',
        time: '',
        days: '',
        roomNo: ''
    });

    // Dialog states
    const [deleteDialog, setDeleteDialog] = useState({ open: false, index: null, type: '' });
    const [editDialog, setEditDialog] = useState({ open: false, index: null, type: '', data: null });

    // Options
    const courseOptions = ['UG', 'PG'];
    const ugYearOptions = ['1st', '2nd', 'BASLP'];
    const pgYearOptions = ['1st', '2nd'];
    const sessionOptions = ['Morning', 'Afternoon'];
    const languageOptions = ['Kannada', 'Hindi', 'Malayalam', 'Telugu', 'Tamil', 'English'];
    const unitOptions = ['Unit 1', 'Unit 2', 'Unit 3', 'Unit 4'];
    const diagnosisOptions = ['DSL secondary to HL', 'Hearing Loss', 'Speech Delay', 'Language Disorder'];
    const deviceOptions = ['Hearing aid', 'CI', 'Hearing aid + CI', 'Bilateral CI'];
    const dayOptions = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const timeSlots = [
        '9:15 to 10:00', '10:00 to 10:45', '10:45 to 11:30', '11:30 to 12:15',
        '1:15 to 2:00', '2:00 to 2:45', '2:45 to 3:30', '3:30 to 4:15'
    ];

    // Student Roster Handlers
    const handleStudentChange = (index, field, value) => {
        const updatedStudents = [...studentRoster.students];
        updatedStudents[index][field] = value;
        
        // Reset year if course changes
        if (field === 'course') {
            updatedStudents[index].year = '';
        }
        
        setStudentRoster(prev => ({ ...prev, students: updatedStudents }));
    };

    const addStudent = () => {
        setStudentRoster(prev => ({
            ...prev,
            students: [...prev.students, { name: '', id: '', course: '', year: '', session: '', languages: [] }]
        }));
    };

    const deleteStudent = (index) => {
        setDeleteDialog({ open: true, index, type: 'student' });
    };

    const editStudent = (index) => {
        setEditDialog({ 
            open: true, 
            index, 
            type: 'student', 
            data: studentRoster.students[index] 
        });
    };

    const handleSaveStudentRoster = () => {
        alert("Student roster saved successfully!");
    };

    // Supervisor List Handlers
    const handleSupervisorChange = (index, field, value) => {
        const updatedSupervisors = [...supervisorList.supervisors];
        updatedSupervisors[index][field] = value;
        setSupervisorList(prev => ({ ...prev, supervisors: updatedSupervisors }));
    };

    const addSupervisor = () => {
        setSupervisorList(prev => ({
            ...prev,
            supervisors: [...prev.supervisors, { name: '', languages: [] }]
        }));
        alert("Supervisor added successfully!");
    };

    const deleteSupervisor = (index) => {
        setDeleteDialog({ open: true, index, type: 'supervisor' });
    };

    const handleSaveSupervisorList = () => {
        alert("Supervisor list saved successfully!");
    };

    // Therapy Slots Handlers
    const handleTherapySlotsChange = (field, value) => {
        setTherapySlots(prev => ({ ...prev, [field]: value }));
    };

    const handleTherapySlotsSubmit = () => {
        alert("Therapy slots saved successfully!");
    };

    // Attendance Handlers
    const handleAttendanceChange = (field, value) => {
        setAttendance(prev => ({ ...prev, [field]: value }));
    };

    const handleAttendanceSubmit = () => {
        alert("Attendance saved successfully!");
    };

    // Therapy Video Handlers
    const handleTherapyVideoChange = (field, value) => {
        setTherapyVideo(prev => ({ ...prev, [field]: value }));
    };

    const handleTherapyVideoSubmit = () => {
        alert("Therapy video submitted successfully!");
    };

    // Report Submission Handlers
    const handlePretherapyChange = (field, value) => {
        setPretherapy(prev => ({ ...prev, [field]: value }));
    };

    const handleLessonPlanChange = (field, value) => {
        setLessonPlan(prev => ({ ...prev, [field]: value }));
    };

    const handleProgressReportChange = (field, value) => {
        setProgressReport(prev => ({ ...prev, [field]: value }));
    };

    const handlePretherapySubmit = () => {
        alert("Pretherapy report submitted successfully!");
    };

    const handleLessonPlanSubmit = () => {
        alert("Lesson plan submitted successfully!");
    };

    const handleProgressReportSubmit = () => {
        alert("Progress report submitted successfully!");
    };

    // Supervisor Section Handlers
    const handleSupervisorPretherapyChange = (field, value) => {
        setSupervisorPretherapy(prev => ({ ...prev, [field]: value }));
    };

    const handleSupervisorLessonPlanChange = (field, value) => {
        setSupervisorLessonPlan(prev => ({ ...prev, [field]: value }));
    };

    const handleSupervisorProgressReportChange = (field, value) => {
        setSupervisorProgressReport(prev => ({ ...prev, [field]: value }));
    };

    const handleSupervisorPretherapySubmit = () => {
        alert("Supervisor pretherapy submitted successfully!");
    };

    const handleSupervisorLessonPlanSubmit = () => {
        alert("Supervisor lesson plan submitted successfully!");
    };

    const handleSupervisorProgressReportSubmit = () => {
        alert("Supervisor progress report submitted successfully!");
    };

    // Dialog Handlers
    const handleDeleteConfirm = () => {
        if (deleteDialog.type === 'student') {
            const updatedStudents = [...studentRoster.students];
            updatedStudents.splice(deleteDialog.index, 1);
            setStudentRoster(prev => ({ ...prev, students: updatedStudents }));
            alert("Student deleted successfully!");
        } else if (deleteDialog.type === 'supervisor') {
            const updatedSupervisors = [...supervisorList.supervisors];
            updatedSupervisors.splice(deleteDialog.index, 1);
            setSupervisorList(prev => ({ ...prev, supervisors: updatedSupervisors }));
            alert("Supervisor deleted successfully!");
        }
        setDeleteDialog({ open: false, index: null, type: '' });
    };

    const handleDeleteCancel = () => {
        setDeleteDialog({ open: false, index: null, type: '' });
    };

    const handleEditSave = () => {
        // Implement edit functionality if needed
        setEditDialog({ open: false, index: null, type: '', data: null });
    };

    const handleEditCancel = () => {
        setEditDialog({ open: false, index: null, type: '', data: null });
    };

    return (
        <Box sx={{ p: 3, maxWidth: 1200, margin: 'auto' }}>
            <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
                Listening Training Unit
            </Typography>

            {/* Student Roster Section */}
            <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                    Student Roster
                </Typography>

                <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>ID</TableCell>
                                <TableCell>Course</TableCell>
                                <TableCell>Year</TableCell>
                                <TableCell>Session</TableCell>
                                <TableCell>Languages</TableCell>
                                <TableCell>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {studentRoster.students.map((student, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <TextField
                                            fullWidth
                                            value={student.name}
                                            onChange={(e) => handleStudentChange(index, 'name', e.target.value)}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            fullWidth
                                            value={student.id}
                                            onChange={(e) => handleStudentChange(index, 'id', e.target.value)}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <FormControl fullWidth>
                                            <Select
                                                value={student.course}
                                                onChange={(e) => handleStudentChange(index, 'course', e.target.value)}
                                            >
                                                {courseOptions.map((course) => (
                                                    <MenuItem key={course} value={course}>{course}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <FormControl fullWidth>
                                            <Select
                                                value={student.year}
                                                onChange={(e) => handleStudentChange(index, 'year', e.target.value)}
                                                disabled={!student.course}
                                            >
                                                {(student.course === 'UG' ? ugYearOptions : pgYearOptions).map((year) => (
                                                    <MenuItem key={year} value={year}>{year}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <FormControl fullWidth>
                                            <Select
                                                value={student.session}
                                                onChange={(e) => handleStudentChange(index, 'session', e.target.value)}
                                            >
                                                {sessionOptions.map((session) => (
                                                    <MenuItem key={session} value={session}>{session}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <FormControl fullWidth>
                                            <Select
                                                multiple
                                                value={student.languages}
                                                onChange={(e) => handleStudentChange(index, 'languages', e.target.value)}
                                                input={<OutlinedInput />}
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {selected.map((value) => (
                                                            <Chip key={value} label={value} />
                                                        ))}
                                                    </Box>
                                                )}
                                            >
                                                {languageOptions.map((language) => (
                                                    <MenuItem key={language} value={language}>
                                                        {language}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => editStudent(index)}
                                            sx={{ mr: 1, mb: 1 }}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            onClick={() => deleteStudent(index)}
                                        >
                                            Delete
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Button
                    variant="outlined"
                    color="primary"
                    onClick={addStudent}
                    sx={{ mb: 2, mr: 2 }}
                >
                    Add Student
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSaveStudentRoster}
                >
                    Save Student Roster
                </Button>
            </Paper>

            {/* Supervisor List Section */}
            <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                    Supervisor List
                </Typography>

                <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Languages</TableCell>
                                <TableCell>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {supervisorList.supervisors.map((supervisor, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <TextField
                                            fullWidth
                                            value={supervisor.name}
                                            onChange={(e) => handleSupervisorChange(index, 'name', e.target.value)}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <FormControl fullWidth>
                                            <Select
                                                multiple
                                                value={supervisor.languages}
                                                onChange={(e) => handleSupervisorChange(index, 'languages', e.target.value)}
                                                input={<OutlinedInput />}
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {selected.map((value) => (
                                                            <Chip key={value} label={value} />
                                                        ))}
                                                    </Box>
                                                )}
                                            >
                                                {languageOptions.map((language) => (
                                                    <MenuItem key={language} value={language}>
                                                        {language}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={addSupervisor}
                                            sx={{ mr: 1, mb: 1 }}
                                        >
                                            Add
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            onClick={() => deleteSupervisor(index)}
                                        >
                                            Delete
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSaveSupervisorList}
                >
                    Save Supervisor List
                </Button>
            </Paper>

            {/* Therapy Slots Section */}
            <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                    Therapy Slots (Clinician List)
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Unit</InputLabel>
                            <Select
                                value={therapySlots.unit}
                                onChange={(e) => handleTherapySlotsChange('unit', e.target.value)}
                                label="Unit"
                            >
                                {unitOptions.map((unit) => (
                                    <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="ID"
                            value={therapySlots.id}
                            onChange={(e) => handleTherapySlotsChange('id', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Client"
                            value={therapySlots.client}
                            onChange={(e) => handleTherapySlotsChange('client', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Diagnosis</InputLabel>
                            <Select
                                value={therapySlots.diagnosis}
                                onChange={(e) => handleTherapySlotsChange('diagnosis', e.target.value)}
                                label="Diagnosis"
                            >
                                {diagnosisOptions.map((diagnosis) => (
                                    <MenuItem key={diagnosis} value={diagnosis}>{diagnosis}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Device</InputLabel>
                            <Select
                                value={therapySlots.device}
                                onChange={(e) => handleTherapySlotsChange('device', e.target.value)}
                                label="Device"
                            >
                                {deviceOptions.map((device) => (
                                    <MenuItem key={device} value={device}>{device}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Language</InputLabel>
                            <Select
                                value={therapySlots.language}
                                onChange={(e) => handleTherapySlotsChange('language', e.target.value)}
                                label="Language"
                            >
                                {languageOptions.map((language) => (
                                    <MenuItem key={language} value={language}>{language}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Session</InputLabel>
                            <Select
                                value={therapySlots.session}
                                onChange={(e) => handleTherapySlotsChange('session', e.target.value)}
                                label="Session"
                            >
                                {sessionOptions.map((session) => (
                                    <MenuItem key={session} value={session}>{session}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Supervisor</InputLabel>
                            <Select
                                value={therapySlots.supervisor}
                                onChange={(e) => handleTherapySlotsChange('supervisor', e.target.value)}
                                label="Supervisor"
                            >
                                {supervisorList.supervisors.map((supervisor, index) => (
                                    <MenuItem key={index} value={supervisor.name}>{supervisor.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Clinician Course</InputLabel>
                            <Select
                                value={therapySlots.clinicianCourse}
                                onChange={(e) => handleTherapySlotsChange('clinicianCourse', e.target.value)}
                                label="Clinician Course"
                            >
                                {courseOptions.map((course) => (
                                    <MenuItem key={course} value={course}>{course}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Clinician Year</InputLabel>
                            <Select
                                value={therapySlots.clinicianYear}
                                onChange={(e) => handleTherapySlotsChange('clinicianYear', e.target.value)}
                                label="Clinician Year"
                                disabled={!therapySlots.clinicianCourse}
                            >
                                {(therapySlots.clinicianCourse === 'UG' ? ugYearOptions : pgYearOptions).map((year) => (
                                    <MenuItem key={year} value={year}>{year}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Clinician Name</InputLabel>
                            <Select
                                value={therapySlots.clinicianName}
                                onChange={(e) => handleTherapySlotsChange('clinicianName', e.target.value)}
                                label="Clinician Name"
                                disabled={!therapySlots.clinicianYear}
                            >
                                {studentRoster.students
                                    .filter(student => student.year === therapySlots.clinicianYear)
                                    .map((student, index) => (
                                        <MenuItem key={index} value={student.name}>{student.name}</MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Room"
                            value={therapySlots.room}
                            onChange={(e) => handleTherapySlotsChange('room', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="From Date"
                            type="date"
                            value={therapySlots.fromDate}
                            onChange={(e) => handleTherapySlotsChange('fromDate', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="To Date"
                            type="date"
                            value={therapySlots.toDate}
                            onChange={(e) => handleTherapySlotsChange('toDate', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel>Days</InputLabel>
                            <Select
                                value={therapySlots.days}
                                onChange={(e) => handleTherapySlotsChange('days', e.target.value)}
                                label="Days"
                            >
                                {dayOptions.map((day) => (
                                    <MenuItem key={day} value={day}>{day}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel>Timings</InputLabel>
                            <Select
                                value={therapySlots.timings}
                                onChange={(e) => handleTherapySlotsChange('timings', e.target.value)}
                                label="Timings"
                            >
                                {timeSlots.map((time) => (
                                    <MenuItem key={time} value={time}>{time}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleTherapySlotsSubmit}
                            fullWidth
                            size="large"
                        >
                            Save Therapy Slots
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            {/* Attendance Section */}
            <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                    Attendance
                </Typography>

                <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Unit</InputLabel>
                            <Select
                                value={attendance.unit}
                                onChange={(e) => handleAttendanceChange('unit', e.target.value)}
                                label="Unit"
                            >
                                {unitOptions.map((unit) => (
                                    <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Date"
                            type="date"
                            value={attendance.date}
                            onChange={(e) => handleAttendanceChange('date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth
                            label="From"
                            type="date"
                            value={attendance.fromDate}
                            onChange={(e) => handleAttendanceChange('fromDate', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth
                            label="To"
                            type="date"
                            value={attendance.toDate}
                            onChange={(e) => handleAttendanceChange('toDate', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>

                <Button
                    variant="outlined"
                    color="primary"
                    sx={{ mb: 3 }}
                >
                    Download Report
                </Button>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Unit</TableCell>
                                <TableCell>ID</TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Diagnosis</TableCell>
                                <TableCell>Device</TableCell>
                                <TableCell>Language</TableCell>
                                <TableCell>Session</TableCell>
                                <TableCell>Supervisor</TableCell>
                                <TableCell>Clinician Name</TableCell>
                                <TableCell>Dates (Present)</TableCell>
                                <TableCell>No of days present</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {/* Attendance data would be populated here */}
                            <TableRow>
                                <TableCell colSpan={11} align="center">
                                    No attendance data available
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAttendanceSubmit}
                    fullWidth
                    sx={{ mt: 2 }}
                >
                    Save Attendance
                </Button>
            </Paper>

            {/* Therapy Video Section */}
            <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                    Therapy Video
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="IP/OP/Internal No"
                            value={therapyVideo.opNumber}
                            onChange={(e) => handleTherapyVideoChange('opNumber', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Case Name"
                            value={therapyVideo.caseName}
                            onChange={(e) => handleTherapyVideoChange('caseName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Student Clinician"
                            value={therapyVideo.studentClinician}
                            onChange={(e) => handleTherapyVideoChange('studentClinician', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Date"
                            type="date"
                            value={therapyVideo.date}
                            onChange={(e) => handleTherapyVideoChange('date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button variant="contained" component="label" fullWidth sx={{ height: '56px' }}>
                            Upload Therapy Video
                            <input
                                type="file"
                                hidden
                                accept="video/*"
                                onChange={(e) => handleTherapyVideoChange('videoFile', e.target.files[0])}
                            />
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            label="Description"
                            value={therapyVideo.description}
                            onChange={(e) => handleTherapyVideoChange('description', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleTherapyVideoSubmit}
                            fullWidth
                            size="large"
                        >
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            {/* Report Submission Section */}
            <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                    Report Submission
                </Typography>

                {/* Pretherapy Subsection */}
                <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
                    Pretherapy
                </Typography>
                <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="IP/OP/Internal No"
                            value={pretherapy.opNumber}
                            onChange={(e) => handlePretherapyChange('opNumber', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Case Name"
                            value={pretherapy.caseName}
                            onChange={(e) => handlePretherapyChange('caseName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Student Clinician"
                            value={pretherapy.studentClinician}
                            onChange={(e) => handlePretherapyChange('studentClinician', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Supervisor"
                            value={pretherapy.supervisor}
                            onChange={(e) => handlePretherapyChange('supervisor', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Age/Gender"
                            value={pretherapy.ageGender}
                            onChange={(e) => handlePretherapyChange('ageGender', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <InputLabel>Language</InputLabel>
                            <Select
                                value={pretherapy.language}
                                onChange={(e) => handlePretherapyChange('language', e.target.value)}
                                label="Language"
                            >
                                {languageOptions.map((lang) => (
                                    <MenuItem key={lang} value={lang}>{lang}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <InputLabel>Device</InputLabel>
                            <Select
                                value={pretherapy.device}
                                onChange={(e) => handlePretherapyChange('device', e.target.value)}
                                label="Device"
                            >
                                {deviceOptions.map((device) => (
                                    <MenuItem key={device} value={device}>{device}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Time"
                            value={pretherapy.time}
                            onChange={(e) => handlePretherapyChange('time', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Days"
                            value={pretherapy.days}
                            onChange={(e) => handlePretherapyChange('days', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Room No"
                            value={pretherapy.roomNo}
                            onChange={(e) => handlePretherapyChange('roomNo', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ alignSelf: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handlePretherapySubmit}
                            fullWidth
                        >
                            Submit Pretherapy
                        </Button>
                    </Grid>
                </Grid>

                {/* Lesson Plan Subsection */}
                <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
                    Lesson Plan
                </Typography>
                <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="IP/OP/Internal No"
                            value={lessonPlan.opNumber}
                            onChange={(e) => handleLessonPlanChange('opNumber', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Case Name"
                            value={lessonPlan.caseName}
                            onChange={(e) => handleLessonPlanChange('caseName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Age/Gender"
                            value={lessonPlan.ageGender}
                            onChange={(e) => handleLessonPlanChange('ageGender', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <InputLabel>Device</InputLabel>
                            <Select
                                value={lessonPlan.device}
                                onChange={(e) => handleLessonPlanChange('device', e.target.value)}
                                label="Device"
                            >
                                {deviceOptions.map((device) => (
                                    <MenuItem key={device} value={device}>{device}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button variant="contained" component="label" fullWidth>
                            Upload Lesson Plan
                            <input
                                type="file"
                                hidden
                                onChange={(e) => handleLessonPlanChange('lessonPlanFile', e.target.files[0])}
                            />
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Supervisor Name"
                            value={lessonPlan.supervisorName}
                            onChange={(e) => handleLessonPlanChange('supervisorName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Time"
                            value={lessonPlan.time}
                            onChange={(e) => handleLessonPlanChange('time', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Days"
                            value={lessonPlan.days}
                            onChange={(e) => handleLessonPlanChange('days', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Room No"
                            value={lessonPlan.roomNo}
                            onChange={(e) => handleLessonPlanChange('roomNo', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ alignSelf: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleLessonPlanSubmit}
                            fullWidth
                        >
                            Submit Lesson Plan
                        </Button>
                    </Grid>
                </Grid>

                {/* Progress Report Subsection */}
                <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
                    Progress Report
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="OP Number"
                            value={progressReport.opNumber}
                            onChange={(e) => handleProgressReportChange('opNumber', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Case Name"
                            value={progressReport.caseName}
                            onChange={(e) => handleProgressReportChange('caseName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Age/Gender"
                            value={progressReport.ageGender}
                            onChange={(e) => handleProgressReportChange('ageGender', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <InputLabel>Device</InputLabel>
                            <Select
                                value={progressReport.device}
                                onChange={(e) => handleProgressReportChange('device', e.target.value)}
                                label="Device"
                            >
                                {deviceOptions.map((device) => (
                                    <MenuItem key={device} value={device}>{device}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button variant="contained" component="label" fullWidth>
                            Upload Report
                            <input
                                type="file"
                                hidden
                                onChange={(e) => handleProgressReportChange('reportFile', e.target.files[0])}
                            />
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Supervisor Name"
                            value={progressReport.supervisorName}
                            onChange={(e) => handleProgressReportChange('supervisorName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Time"
                            value={progressReport.time}
                            onChange={(e) => handleProgressReportChange('time', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Days"
                            value={progressReport.days}
                            onChange={(e) => handleProgressReportChange('days', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Room No"
                            value={progressReport.roomNo}
                            onChange={(e) => handleProgressReportChange('roomNo', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ alignSelf: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleProgressReportSubmit}
                            fullWidth
                        >
                            Submit Report
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            {/* Supervisor Section */}
            <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                    Supervisor
                </Typography>

                {/* Pretherapy Subsection */}
                <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
                    Pretherapy
                </Typography>
                <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="IP/OP/Internal No"
                            value={supervisorPretherapy.opNumber}
                            onChange={(e) => handleSupervisorPretherapyChange('opNumber', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Case Name"
                            value={supervisorPretherapy.caseName}
                            onChange={(e) => handleSupervisorPretherapyChange('caseName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Age/Gender"
                            value={supervisorPretherapy.ageGender}
                            onChange={(e) => handleSupervisorPretherapyChange('ageGender', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <InputLabel>Language</InputLabel>
                            <Select
                                value={supervisorPretherapy.language}
                                onChange={(e) => handleSupervisorPretherapyChange('language', e.target.value)}
                                label="Language"
                            >
                                {languageOptions.map((lang) => (
                                    <MenuItem key={lang} value={lang}>{lang}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <InputLabel>Device</InputLabel>
                            <Select
                                value={supervisorPretherapy.device}
                                onChange={(e) => handleSupervisorPretherapyChange('device', e.target.value)}
                                label="Device"
                            >
                                {deviceOptions.map((device) => (
                                    <MenuItem key={device} value={device}>{device}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Student Name"
                            value={supervisorPretherapy.studentName}
                            onChange={(e) => handleSupervisorPretherapyChange('studentName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Time"
                            value={supervisorPretherapy.time}
                            onChange={(e) => handleSupervisorPretherapyChange('time', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Days"
                            value={supervisorPretherapy.days}
                            onChange={(e) => handleSupervisorPretherapyChange('days', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Room No"
                            value={supervisorPretherapy.roomNo}
                            onChange={(e) => handleSupervisorPretherapyChange('roomNo', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSupervisorPretherapySubmit}
                            fullWidth
                        >
                            Submit Pretherapy
                        </Button>
                    </Grid>
                </Grid>

                {/* Lesson Plan Subsection */}
                <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
                    Lesson Plan
                </Typography>
                <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="OP Number"
                            value={supervisorLessonPlan.opNumber}
                            onChange={(e) => handleSupervisorLessonPlanChange('opNumber', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Case Name"
                            value={supervisorLessonPlan.caseName}
                            onChange={(e) => handleSupervisorLessonPlanChange('caseName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Age/Gender"
                            value={supervisorLessonPlan.ageGender}
                            onChange={(e) => handleSupervisorLessonPlanChange('ageGender', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <InputLabel>Device</InputLabel>
                            <Select
                                value={supervisorLessonPlan.device}
                                onChange={(e) => handleSupervisorLessonPlanChange('device', e.target.value)}
                                label="Device"
                            >
                                {deviceOptions.map((device) => (
                                    <MenuItem key={device} value={device}>{device}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button variant="contained" component="label" fullWidth>
                            Upload Lesson Plan
                            <input
                                type="file"
                                hidden
                                onChange={(e) => handleSupervisorLessonPlanChange('lessonPlanFile', e.target.files[0])}
                            />
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Student Name"
                            value={supervisorLessonPlan.studentName}
                            onChange={(e) => handleSupervisorLessonPlanChange('studentName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Time"
                            value={supervisorLessonPlan.time}
                            onChange={(e) => handleSupervisorLessonPlanChange('time', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Days"
                            value={supervisorLessonPlan.days}
                            onChange={(e) => handleSupervisorLessonPlanChange('days', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Room No"
                            value={supervisorLessonPlan.roomNo}
                            onChange={(e) => handleSupervisorLessonPlanChange('roomNo', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSupervisorLessonPlanSubmit}
                            fullWidth
                        >
                            Submit Lesson Plan
                        </Button>
                    </Grid>
                </Grid>

                {/* Progress Report Subsection */}
                <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
                    Progress Report
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="OP Number"
                            value={supervisorProgressReport.opNumber}
                            onChange={(e) => handleSupervisorProgressReportChange('opNumber', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Case Name"
                            value={supervisorProgressReport.caseName}
                            onChange={(e) => handleSupervisorProgressReportChange('caseName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Age/Gender"
                            value={supervisorProgressReport.ageGender}
                            onChange={(e) => handleSupervisorProgressReportChange('ageGender', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <InputLabel>Device</InputLabel>
                            <Select
                                value={supervisorProgressReport.device}
                                onChange={(e) => handleSupervisorProgressReportChange('device', e.target.value)}
                                label="Device"
                            >
                                {deviceOptions.map((device) => (
                                    <MenuItem key={device} value={device}>{device}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                     </Grid>
                    <Grid item xs={12} md={4}>
                        <Button variant="contained" component="label" fullWidth>
                            Upload Report
                            <input
                                type="file"
                                hidden
                                onChange={(e) => handleSupervisorProgressReportChange('reportFile', e.target.files[0])}
                            />
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Student Name"
                            value={supervisorProgressReport.studentName}
                            onChange={(e) => handleSupervisorProgressReportChange('studentName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Time"
                            value={supervisorProgressReport.time}
                            onChange={(e) => handleSupervisorProgressReportChange('time', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Days"
                            value={supervisorProgressReport.days}
                            onChange={(e) => handleSupervisorProgressReportChange('days', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Room No"
                            value={supervisorProgressReport.roomNo}
                            onChange={(e) => handleSupervisorProgressReportChange('roomNo', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSupervisorProgressReportSubmit}
                            fullWidth
                        >
                            Submit Report
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={deleteDialog.open}
                onClose={handleDeleteCancel}
            >
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this {deleteDialog.type}? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel}>Close</Button>
                    <Button onClick={handleDeleteConfirm} color="error" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Dialog */}
            <Dialog
                open={editDialog.open}
                onClose={handleEditCancel}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Edit {editDialog.type}</DialogTitle>
                <DialogContent>
                    {/* Edit form would go here */}
                    <Typography>Edit functionality to be implemented</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleEditCancel}>Cancel</Button>
                    <Button onClick={handleEditSave} color="primary">
                        Save Changes
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ListeningTrainingUnit;